import { BaseContract, BigNumber } from 'ethers';
import toast from 'react-hot-toast';

import { AddressType } from 'types';

export const checkERC20Balance = async (erc20Contract: BaseContract, address: AddressType, amount: bigint | BigNumber, customMessage?: string) => {
  const [balance] = await erc20Contract.functions.balanceOf(address);

  if (balance.lt(amount)) {
    toast.error(customMessage || 'You do not have enough funds to accept the loan request.');
    return false;
  }
  return true;
};
